import React, { useEffect, useState } from "react";
import {showToast, TOAST_TYPE} from "deskera-ui-library";
import { useDispatch, useSelector } from "react-redux";
import { fetchAISSummary, selectAISSummary, selectSubmissionLogs } from "../../../../../Redux/Slices/AISSubmissionSlice";
import Utility, { deepClone } from "../../../../../utility/Utility";
import MaskInputUtil from "../../../../../SharedComponents/MaskInput/MaskInputUtil";
import TenantManager from "../../../../../managers/TenantManager";
import { aisSummaryColumnConfig, parseVisibleColumnConfig } from "../../../../configs/config";
import {TableManger, TABLES} from "../../../../../managers/TableManger"
import DataGridHolderPayroll from "../../../../common/DataGridHolderPayroll";
import ApiConstants from "../../../../../constants/ApiConstants";


const IRASSubmission = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    /**Hooks */
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails)
    const [reload, setReload] = useState(false);
    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
      setMask(mask);
      setReload(!reload);
    });
    const [employee, setEmployee] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(20);
    const [requestParameter, setRequestParameter] = useState(props?.data?.params);

    /**Selectors */
    const summaryDetails = useSelector(selectAISSummary);

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        if(props?.data?.isUpdateTrigerred) {
            loadAISSummaryDetails(props?.data?.params)
        }
    },[props])

    useEffect(() => {
        if(!Utility.isEmpty(summaryDetails)) {
            const { employee, filterConfig, cpfAccountId } = summaryDetails;
            const functionConfig = getFunctionConfig()
            const rowData = aisSummaryColumnConfig(
                employee,
                functionConfig,
                "IRAS_SUBMISSION"
            );
            let columns = TableManger.getTableColumns(TABLES.PEOPLE_IRAS_AIS_SUBMISSION);
            let employeeColumn = parseVisibleColumnConfig(columns);
            const passingData = {
                columnData: deepClone(employeeColumn),
                rowData,
                filter: [],
                originalData: rowData,
              };
            setEmployee(passingData);
            setTotalPageCount(parseInt(filterConfig.totalPage));
            setCurrentPage(parseInt(filterConfig.page));
            setTotalCount(parseInt(filterConfig.numberOfRecords));
        }

    },[summaryDetails]);

    const loadAISSummaryDetails = async (config) => {
        try{
            const configDetail = {
                Limit: config.limit,
                CurrentPage: config.page,
                field: config.field,
                order: config.order,
                cpfAccountId: config.cpfAccountId,
                year:config.year
              };
            await dispatch(fetchAISSummary(configDetail))
        }catch(err) {
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        }
    }

    const getFunctionConfig = () => {
      return {
        "routeForAppendment" : routeToViewAmendmentRules
      }
    }

    const routeToViewAmendmentRules = () => {
      window.open(ApiConstants.ROUTE_TO_IRAS_AMMENDMENT, "_blank");
    }

    return(
        <>
            <div className="column parent-width flex-1">
            <div className="column mt-l parent-width mb-s position-relative flex-1">
              <DataGridHolderPayroll
                tableName={TABLES.PEOPLE_IRAS_AIS_SUBMISSION}
                displayTableName={""}
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowColumnAdd={false}
                onSelection={(data)=>{
                  props.onRowSelection(data);
                }}
                gridData={employee}
                onPaginationClick={(requestedPageNumber) => {
                  const config = {
                    page: requestedPageNumber,
                  };
                  loadAISSummaryDetails(config);
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={false}
                contextMenu={false}
                isMenuVisible={false}
                allowRowEdit={true}
                showContextEdit={false}
              />
            </div>
          </div>
        </>
    )

}

export default IRASSubmission;